// The short notices in the corner: MudSnackbar as the Blazor cabinet used it.

import { h } from './dom.ts';

const VISIBLE_MS = 4000;

let container: HTMLElement | null = null;

export function snackbar(message: string, severity: 'success' | 'error' = 'success'): void {
    if (!message) return;

    if (!container) {
        container = h('div', { class: 'snackbars', role: 'status', 'aria-live': 'polite' });
        document.body.appendChild(container);
    }

    const item = h('div', { class: `snackbar ${severity}` },
        h('span', { class: 'snackbar-icon', 'aria-hidden': 'true' }, severity === 'success' ? '✓' : '!'),
        h('span', null, message));

    container.appendChild(item);
    requestAnimationFrame(() => item.classList.add('shown'));

    setTimeout(() => {
        item.classList.remove('shown');
        setTimeout(() => item.remove(), 300);
    }, VISIBLE_MS);
}
